import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { memoize } from 'lodash';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import {
    PhrasesSelectorKeywordsActions,
    PhrasesSelectorPhrase,
    PhrasesSelectorWizardId
} from '../../../typings/phrases';
import { ScreenErrorMessage } from '../../ScreenErrorMessage/ScreenErrorMessage';
import { SelectionList } from '../../SelectionList/SelectionList';
import { PhrasesSelectorKeywordsCell } from '../PhrasesSelectorKeywordsCell/PhrasesSelectorKeywordsCell';
import {
    PhrasesSelectorSelectedBlock,
    PhrasesSelectorSelectedBlockActions
} from '../PhrasesSelectorSelectedBlock/PhrasesSelectorSelectedBlock';

import './PhrasesSelectorKeywords.css';
import * as keyset from './PhrasesSelectorKeywords.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasesSelectorKeywordsProps {
    wizardId: PhrasesSelectorWizardId;
    keywords: Array<PhrasesSelectorPhrase>;
    onRemove: (index: number) => void;
    onRefine: (index: number, phrase: PhrasesSelectorPhrase) => void;
    onRefinePopupOpenMetrica: () => void;
    onKeywordsClear: () => void;
}

const BLOCK = 'phrases-selector-keywords';

export class PhrasesSelectorKeywords extends React.PureComponent<PhrasesSelectorKeywordsProps> {
    private keywordsColumns = [
        {
            getCellContent: (rowIndex: number) => {
                const { keywords, wizardId, onRemove, onRefine, onRefinePopupOpenMetrica } = this.props;
                const item = keywords[rowIndex];

                return (
                    <PhrasesSelectorKeywordsCell
                        wizardId={wizardId}
                        index={rowIndex}
                        keyword={item}
                        onRemove={onRemove}
                        onRefine={onRefine}
                        onRefinePopupOpenMetrica={onRefinePopupOpenMetrica}
                    />
                );
            },
            flexGrow: 1
        }
    ];

    private getActions = memoize(
        (areKeywordsEmpty: boolean): Record<string, PhrasesSelectorSelectedBlockActions> => ({
            [PhrasesSelectorKeywordsActions.remove]: {
                info: {
                    text: i18n('remove-action'),
                    val: PhrasesSelectorKeywordsActions.remove,
                    elemMods: {
                        disabled: areKeywordsEmpty
                    }
                },
                handler: this.props.onKeywordsClear
            }
        })
    );

    render() {
        const keywordsCount = this.props.keywords.length;

        return (
            <PhrasesSelectorSelectedBlock
                className={classNames(Bem.cls(BLOCK), TestBem.cls(BLOCK))}
                title={i18n('title')}
                actions={this.getActions(keywordsCount === 0)}
            >
                {keywordsCount === 0 ? (
                    <div className={Bem.cls(BLOCK, 'empty-message-wrapper')}>
                        <ScreenErrorMessage
                            cls={Bem.cls(BLOCK, 'empty-message')}
                            header={i18n('empty-header')}
                            text={i18n('empty-text')}
                        />
                    </div>
                ) : (
                    <SelectionList
                        cls={Bem.cls(BLOCK, 'list')}
                        columns={this.keywordsColumns}
                        rowsCount={keywordsCount}
                        rowClassNameGetter={this.rowClassNameGetter}
                        rowHeight={38}
                    />
                )}
            </PhrasesSelectorSelectedBlock>
        );
    }

    private rowClassNameGetter = () => Bem.cls(BLOCK, 'selection-row');
}
